var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnglesRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54285 7.74878L3.23035 2.43628C2.81531 2.02124 2.14295 2.02124 1.72791 2.43628C1.31287 2.85132 1.31287 3.52368 1.72791 3.93872L6.29168 8.49917L1.72957 13.0613C1.31453 13.4763 1.31453 14.1487 1.72957 14.5637C1.93642 14.7712 2.20802 14.8742 2.47996 14.8742C2.75189 14.8742 3.02383 14.7704 3.23101 14.5629L8.54352 9.25039C8.95789 8.83452 8.95789 8.16382 8.54285 7.74878ZM14.9179 7.74878L9.60536 2.43628C9.19032 2.02124 8.51795 2.02124 8.10291 2.43628C7.68787 2.85132 7.68787 3.52368 8.10291 3.93872L12.6667 8.49917L8.10457 13.0613C7.68953 13.4763 7.68953 14.1487 8.10457 14.5637C8.31043 14.7712 8.5827 14.8742 8.85496 14.8742C9.12723 14.8742 9.39883 14.7704 9.60602 14.5629L14.9185 9.25039C15.3329 8.83452 15.3329 8.16382 14.9179 7.74878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnglesRight);
export default __webpack_public_path__ + "static/media/angles-right.614b5f438b2468271a4d2f4c85bcb212.svg";
export { ForwardRef as ReactComponent };